var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomCardIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1868_4002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07171 20.9827L1.35742 23.1427L3.51742 15.4284L17.6431 1.37126C17.8028 1.20798 17.9935 1.07824 18.2039 0.989668C18.4144 0.901095 18.6405 0.855469 18.8689 0.855469C19.0972 0.855469 19.3233 0.901095 19.5338 0.989668C19.7442 1.07824 19.9349 1.20798 20.0946 1.37126L23.1289 4.42268C23.2895 4.58205 23.4171 4.77165 23.5041 4.98055C23.5911 5.18945 23.6359 5.41352 23.6359 5.63983C23.6359 5.86613 23.5911 6.0902 23.5041 6.2991C23.4171 6.508 23.2895 6.6976 23.1289 6.85697L9.07171 20.9827Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1868_4002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCardIconWhite);
export default __webpack_public_path__ + "static/media/custom-card-icon-white.a75f2086eb25420f474d639f02b88033.svg";
export { ForwardRef as ReactComponent };